import React from 'react';
import styled from 'App/styled';

import Price from './PriceInfo';


interface StickyInfoProps {
  discount: number;
  mrp: number;
  offerPrice: number;
  name: string;
  children: React.ReactNode;
}

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 7px 0 rgba(0,0,0,.1), 0 -1px 7px 0 rgba(0,0,0,.1);

  .initial {
    padding: 0 15px 5px;
    position: static !important;
    max-width: 100%;
  }
`;

const Info = styled.div`
  padding: 8px 15px;
  display: flex;
  justify-content: space-between;
`;

const Name = styled.span`
  width: 44%;
  padding-right: 2%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ theme }) => theme.typography.subTitleMedium};
`;

const StickyInfo = ({
  discount,
  mrp,
  offerPrice,
  name,
  children,
}: StickyInfoProps) => {
  const priceInfo = {
    mrp,
    offerPrice,
    discount,
  };
  return (
    <Wrapper>
      <Info>
        <Name>
          {name}
        </Name>
        <Price priceInfo={priceInfo} />
      </Info>
      {children}
    </Wrapper>
  );
};

export default StickyInfo;
